<template>
  <div>
    <div v-if="showBrandedContent" class="text-left">
      <h1 class="u-margin-top-0x">
        {{
          $t('SignupForm.branding.title', {
            country: $t(`SignupForm.branding.${studyCountry}`)
          })
        }}
      </h1>
      <p>
        {{
          $t('SignupForm.branding.blurb', {
            country: $t(`SignupForm.branding.${studyCountry}`)
          })
        }}
      </p>
      <div class="text-left">
        <span v-if="studyReportsLink">
          <a :href="studyReportsLink" class="u-padding-right-1x">{{
            $t('SignupForm.branding.reportLink')
          }}</a>
          |
        </span>
        <a :href="studyFaqsLink" class="u-padding-left-1x u-padding-right-1x">{{
          $t('SignupForm.branding.faqsLink')
        }}</a>
        |
        <a
          href="mailto:community@samknows.com"
          target="_blank"
          class="u-padding-left-1x"
          >{{ $t('SignupForm.branding.contactUs') }}</a
        >
      </div>
    </div>
    <img :alt="studyName" :src="studyImage" class="branded-image hidden-xs" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';

import { formConfig } from '../../volunteer-form.config';
import { createFaqsLink } from '../../helpers/volunteer.helper';
import { ORGANISATIONS } from '../../constants';

export default defineComponent({
  name: 'BrandedSignupSection',
  props: {
    owner: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const formConfigForOwner = ref(formConfig[props.owner] || {});
    const showBrandedContent = [
      ORGANISATIONS.COM_COM,
      ORGANISATIONS.TRA
    ].includes(props.owner as ORGANISATIONS);
    const studyName = computed(() => {
      return formConfigForOwner.value?.studyName;
    });
    const studyReportsLink = computed(() => {
      return formConfigForOwner.value?.branding?.reportsLink;
    });
    const studyImage = computed(() => {
      return formConfigForOwner.value?.branding?.image;
    });
    const studyCountry = computed(() => {
      return formConfigForOwner.value?.country;
    });
    const studyFaqsLink = computed((): string => {
      return createFaqsLink(props.owner);
    });

    return {
      showBrandedContent,
      studyName,
      studyReportsLink,
      studyImage,
      studyCountry,
      studyFaqsLink
    };
  }
});
</script>

<style lang="scss">
.branded-image {
  max-width: 80%;
}
</style>
